/**
 * Pure mutation functions for comment thread actions.
 */

import type {ICommentThreadData, IDocumentData} from "@buildwithflux/models";

// =========================================================================
// Pure mutation functions (used by both handlers and direct store methods)
// =========================================================================

export function applyCreateCommentThread(draft: IDocumentData, commentThread: ICommentThreadData): void {
    draft.comment_threads[commentThread.uid] = commentThread;
}

export function applyIncrementCommentThreadCommentCount(draft: IDocumentData, commentThreadUid: string): void {
    const thread = draft.comment_threads[commentThreadUid];
    if (thread) {
        thread.comment_count = thread.comment_count ? thread.comment_count + 1 : 1;
        thread.updated_at = Date.now();
    }
}

export function applyPinCommentThread(draft: IDocumentData, commentThreadUid: string, pinned: boolean): void {
    const thread = draft.comment_threads[commentThreadUid];
    if (thread) {
        thread.pinned = pinned;
        thread.updated_at = Date.now();
    }
}

export function applyResolveCommentThread(draft: IDocumentData, commentThreadUid: string): void {
    const thread = draft.comment_threads[commentThreadUid];
    if (thread) {
        thread.resolved = true;
        thread.updated_at = Date.now();
    }
}

export function applyUnresolveCommentThread(draft: IDocumentData, commentThreadUid: string): void {
    const thread = draft.comment_threads[commentThreadUid];
    if (thread) {
        thread.resolved = false;
        thread.updated_at = Date.now();
    }
}

export function applyDeleteCommentThread(draft: IDocumentData, commentThreadUid: string): void {
    delete draft.comment_threads[commentThreadUid];
}

export function applyUpdateCommentThreadsPositionAnchor(
    draft: IDocumentData,
    commentThreads: ICommentThreadData[],
): void {
    for (const existingThread of Object.values(draft.comment_threads)) {
        const update = commentThreads.find((e) => e.uid === existingThread.uid);
        if (update) {
            existingThread.anchor = update.anchor;
            existingThread.updated_at = Date.now();
        }
    }
}
